import styled from 'styled-components';
import tw from 'twin.macro';

const DebtCancellationContainer = styled.div`
  ${tw`border border-gray-300 p-4 mb-4 border-solid`}
`;

const Title = styled.div`
  ${tw`font-bold text-sm mb-3`}
`;

const Description = styled.div`
  ${tw`text-sm mb-4`}
`;

const FormRow = styled.div`
  ${tw`flex gap-2 mb-2`}
`;

const Label = styled.span`
  ${tw`text-sm`}
`;

const SignatureSection = styled.div`
  ${tw`mt-4`}
`;

const SignatureLine = styled.div`
  ${tw`border-b border-gray-600 w-48 mt-1`}
`;

const OptionalDebtSectionComponent = () => {
  return (
    <DebtCancellationContainer>
      <Title>OPTIONAL DEBT CANCELLATION AGREEMENT OR GUARANTEED ASSET PROTECTION WAIVER.</Title>

      <Description>
        A debt cancellation agreement or guaranteed asset protection waiver (GAP waiver) is not
        required to obtain credit and will not be provided unless you sign below and agree to pay
        the extra charge. If you choose to buy debt cancellation or a GAP waiver, the charge is
        shown in item 1L of the Itemization of Amount Financed. See your agreement for details on
        the terms and conditions it provides. It is a part of this contract.
      </Description>

      <FormRow>
        <Label>Term</Label>

        <Label>Mos.</Label>
      </FormRow>

      <FormRow>
        <Label>Name of Agreement: _______________________</Label>
      </FormRow>

      <SignatureSection>
        <Description>I want to buy a debt cancellation agreement or GAP waiver.</Description>
        <Label>Buyer Signs X: _______________________</Label>
        <SignatureLine />
      </SignatureSection>
    </DebtCancellationContainer>
  );
};

export default OptionalDebtSectionComponent;
